/**
 * BALANCE REPORT -- ENDPOINTS
 * @description
 * Endpoint owned by the casino-auth service, reached through the admin API
 * (REACT_APP_SERVER_INCENTIVE_API) with `isIncentiveAPI: true`.
 * Final path to be confirmed by the backend team; it follows the existing
 * `adm/api/casino-auth/v1/players/...` namespace.
 */
// eslint-disable-next-line
export const BALANCE_REPORT = {
  FIND: 'adm/api/casino-auth/v1/players/balance-report',
}
